import React, { useEffect, useState } from "react";
import Chart from "react-google-charts";
import * as Funciones from "../../../../utils/funciones";
import styles from "./grafico-proyecciones.module.css";

const GraficoProyecciones = ({ escenarios, codigoMoneda }) => {
    const initialState = {
        datos: [],
        valorRescateMax: 0,
        minEdad: 0,
        maxEdad: 100
    }
    const [ state, setState ] = useState(initialState)

    const obtenerToolTip = (edad, valorEsperado, valorPesimista, valorOptimista, codigoMoneda) => {
        return "<div class='tooltip_grafico'>" +
                "<div class='tooltip_contenido'>" +
                    "<span class='tooltip_anio'>" +
                        "VALOR DE RESCATE" +
                    "</span>" +
                "</div>" +
                "<div class='tooltip_contenido'>" +
                    "<span class='tooltip_anio'>" +
                        "(" + edad + " AÑOS)" +
                    "</span>" +
                "</div>" +

                "<div class='tooltip_contenido'>" +
                    "<div class='tooltip_point tooltip_point_esperado'></div>" +
                    "<span class='tooltip_text'>" +
                        "TIR esperada" +
                    "</span>" +
                "</div>" +
                "<div class='tooltip_contenido'>" +
                    "<span class='tooltip_text tooltip_negrita'>" +
                        Funciones.mostrarFormatoMoneda(valorEsperado, codigoMoneda, true) +
                    "</span>" +
                "</div>" +

                "<div class='tooltip_contenido'>" +
                    "<div class='tooltip_point tooltip_point_pesimista'></div>" +
                    "<span class='tooltip_text'>" +
                        "TIR pesimista" +
                    "</span>" +
                "</div>" +
                "<div class='tooltip_contenido'>" +
                    "<span class='tooltip_text tooltip_negrita'>" +
                        Funciones.mostrarFormatoMoneda(valorPesimista, codigoMoneda, true) +
                    "</span>" +
                "</div>" +

                "<div class='tooltip_contenido'>" +
                    "<div class='tooltip_point tooltip_point_optimista'></div>" +
                    "<span class='tooltip_text'>" +
                        "TIR optimista" +
                    "</span>" +
                "</div>" +
                "<div class='tooltip_contenido'>" +
                    "<span class='tooltip_text tooltip_negrita'>" +
                        Funciones.mostrarFormatoMoneda(valorOptimista, codigoMoneda, true) +
                    "</span>" +
                "</div>" +
            "</div>"
    }

    const ordenarDatos = (escenarios) => {
        let datosAux = [[
            "Año",
            { role: "tooltip", type: "string", p: { html: true } },
            "Escenario Esperado",
            "Escenario Pesimista", 
            "Escenario Optimista"
        ]]
        let escenarioEsperado = escenarios.filter(escenario => escenario.nombre === 'Escenario Esperado')[0]
        let escenarioPesimista = escenarios.filter(escenario => escenario.nombre === 'Escenario Pesimista')[0]
        let escenarioOptimista = escenarios.filter(escenario => escenario.nombre === 'Escenario Optimista')[0]
        let proyeccionesEsperado = Funciones.ordenarListaXCampo(true, escenarioEsperado.proyecciones, 'anio')
        let proyeccionesPesimista = Funciones.ordenarListaXCampo(true, escenarioPesimista.proyecciones, 'anio')
        let proyeccionesOptimista = Funciones.ordenarListaXCampo(true, escenarioOptimista.proyecciones, 'anio')
        let valorRescateMax = 0

        for(let i = 0; i < escenarios[0].proyecciones.length; i++) {
            valorRescateMax = proyeccionesEsperado[i].valorRescate >= valorRescateMax ? escenarioEsperado.proyecciones[i].valorRescate : valorRescateMax
            valorRescateMax = proyeccionesPesimista[i].valorRescate >= valorRescateMax ? escenarioPesimista.proyecciones[i].valorRescate : valorRescateMax
            valorRescateMax = proyeccionesOptimista[i].valorRescate >= valorRescateMax ? escenarioOptimista.proyecciones[i].valorRescate : valorRescateMax
            datosAux.push([
                proyeccionesEsperado[i].edad,
                obtenerToolTip(proyeccionesEsperado[i].edad, proyeccionesEsperado[i].valorRescate, proyeccionesPesimista[i].valorRescate,
                    proyeccionesOptimista[i].valorRescate, codigoMoneda),
                proyeccionesEsperado[i].valorRescate,
                proyeccionesPesimista[i].valorRescate,
                proyeccionesOptimista[i].valorRescate
            ])
        }

        setState({
            ...state,
            datos: datosAux,
            valorRescateMax: valorRescateMax * 1.2,
            minEdad: proyeccionesEsperado[0].edad,
            maxEdad: proyeccionesEsperado[proyeccionesEsperado.length - 1].edad
        })
    }

    useEffect(() => {
        ordenarDatos(escenarios)
    }, [ escenarios ])

    const options = {
        title: "",
        curveType: "function",
        legend: { position: "none" },
        tooltip: { isHtml: true },
        lineWidth: 2,
        colors: ["#0099cc", "#ee2c70", "#00af3f"],
        height	: 500,
        width: 900,
        chartArea: {left: 70, right: 10, top: 30, bottom: 20},
        hAxis: {
            gridlines: { count: (escenarios[0].proyecciones.length / 1) },
            textStyle : {
                fontSize : 12,
                color :'#444444'
            },
            slantedText : false,
            viewWindow : {
                min : state.minEdad,
                max : state.maxEdad
            }
        },
        vAxis: {
            gridlines: { count: 2 },
            viewWindow : {
                min : 0,
                max : state.valorRescateMax
            }
        },
        crosshair: {
            trigger: 'both',
            orientation: 'vertical',
            opacity: 0.5,
            color: '#444444'
        },
        focusTarget: "category"
    }

    return (
        <React.Fragment>
            <Chart
                chartType="LineChart"
                width="100%"
                height="100%"
                data={state.datos}
                options={options}
            />
            <div className={styles.axisH}>
                <span className={styles.axisH_titulo}>
                    AÑOS DEL ASEGURADO
                </span>
            </div>
        </React.Fragment>
    )
}

export default GraficoProyecciones;